module.exports = __webpack_public_path__ + "static/media/checkit.be05d06a.jpg";